import * as React from 'react';
import CardContainer from '../common/CardContainer';
// import CC2 from '../common/CardContainer.redesign';
import { Card } from '@blueprintjs/core';
import CardScrollSection from '../common/CardScrollSection';
import { Bar } from 'react-chartjs-2';
// import TractCard from '../project/sections/TractComponents/TractCard2';
import { TractSummary, HorizonSummary } from 'src/models/Tract';
// import useFetch from 'use-http';
// import FormDatePicker from '../controls/forms/FormDatePicker';
// import Form from '../controls/forms/Form';

type MainPage_DefaultProps = {
    trackedProjects: Array<JSX.Element>;
    taskItems: Array<JSX.Element>;
    tasksIsLoading: boolean;
};

// // TODO: For Testing, remove later
// const TestPDF: React.FC<{}> = props => {

//     const { post, response } = useFetch();

//     const loadData = async () => {
//         await post('v1.0/reports', { type: 1, output: 2, resourceId: '3.1.1.1-1' });
//         if (response.ok) {
//             console.log(response.headers.get('Content-Disposition'));
//             await response.blob().then(blob => {
//                 let blobUrl = window.URL.createObjectURL(blob);
//                 let a = document.getElementById('rep') as HTMLAnchorElement;
//                 a.href = blobUrl;
//                 // filename issues
//                 a.download = 'MineralOwnership.pdf';
//                 a.click();
//                 window.URL.revokeObjectURL(blobUrl);
//             });
//         }
//     };

//     return (
//         <>
//             <a style={{ display: 'hidden' }} id="rep" />
//             <div onClick={loadData}>Report</div>
//         </>
//     );
// };

const mainPageDefault: React.FC<MainPage_DefaultProps> = (props: MainPage_DefaultProps) => {
    const tract = new TractSummary();
    tract.tractNumber = 12;
    tract.isPlotted = 'true';
    tract.legalDescription = 'nw/4';
    tract.lastModified = '2/14/2019';

    const hor1 = new HorizonSummary();
    hor1.name = 'From Surface to 2000ft';
    hor1.number = 1;
    hor1.gross = 80;
    hor1.hbp = 0;
    hor1.open = 0;
    hor1.leased = 0;

    const hor2 = { ...hor1 };
    hor2.number = 2;
    hor2.name = '2000ft to center of Earth';

    tract.horizons = [hor1, hor2];

    const t2 = { ...tract };
    t2.tractNumber = 13;
    t2.legalDescription = 'ne/4';
    t2.horizons = [hor1];

    const data = {
        labels: ['4/29/18 (Sun)', '4/30/18 (Mon)', '5/1/18 (Tue)', '5/2/18 (Wed)', '5/3/18 (Thu)', '5/4/18 (Fri)', '5/5/18 (Sat)'],
        datasets: [
            {
                label: 'Hours Billed',
                backgroundColor: 'rgba(124,156,237.2)',
                borderColor: 'rgba(124,156,237,1)',
                borderWidth: 1,
                hoverBackgroundColor: 'rgba(124,156,237,0.4)',
                hoverBorderColor: 'rgba(124,156,237,1)',
                data: [0, 4, 10, 8, 4, 5.25, 0],
            },
        ],
    };

    return (
        <>
            <CardContainer height="25rem">
                <Card elevation={2}>
                    <div className="card-header lh-mb-small">Tracked Projects</div>
                    <CardScrollSection height="130px" isLoading={props.tasksIsLoading} emptyMessage="No Tracked Projects">
                        {/* {props.trackedProjects} */}
                    </CardScrollSection>
                </Card>
                <Card elevation={2}>
                    <div className="card-header lh-mb-small">Tasks</div>
                    <CardScrollSection height="130px" isLoading={props.tasksIsLoading} emptyMessage="No Tasks">
                        {/* {props.taskItems} */}
                    </CardScrollSection>
                </Card>
            </CardContainer>
            <div style={{ display: 'none' }}>
                <CardContainer>
                    <Card elevation={2}>
                        <div className="card-header lh-mb-small">Logged Time</div>
                        <Bar data={data} height={200} options={{ maintainAspectRatio: false }} />
                    </Card>
                </CardContainer>
            </div>

            {/* <div style={{ maxWidth: '60%' }}>
                <Form onSubmit={(values) => console.log(values)}>
                    <FormDatePicker name="date" />
                </Form>
            </div> */}
        </>
    );
};

export default mainPageDefault;



// WEBPACK FOOTER //
// ./src/components/main/MainPage.Default.tsx